/*
 * @Description:
 * @Version: 2.0
 * @Author: Zed
 * @Date: 2020-09-28 19:29:53
 * @LastEditors: Zed
 * @LastEditTime: 2020-10-13 19:22:31
 */
import req from "@/api/config/config";
export default {
  getPicCode(parmas) {
    // 获取密码登录验证码图片
    return req.service({
      url: "/",
      method: "post",
      parmas: parmas,
    });
  },

  // 修改密码
  editSupplier(data) {
    return req.service({
      url: `${req.systemIp}/website/supplier/editSupplier`,
      method: "put",
      data,
    });
  },

  // 修改手机号码
  modifySupplierPhone(params) {
    return req.service({
      url: `${req.systemIp}/website/supplier/modifySupplierPhone`,
      method: "put",
      params,
    });
  },

  ////////////////////////////////////////////

  //图行验证
  verifyCode() {
    return req.service({
      url: `${req.systemIp}/captcha`,
      method: "get",
    });
  },

  //登录
  login(params) {
    return req.service({
      url: `${req.systemIp}/pc/ext/supplier/user/account/login`,
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
        "BIDDING-SOURCE": "pc/ext",
      },
      params,
    });
  },

  // 修改密码
  editSupplier(data) {
    return req.service({
      url: `${req.systemIp}/pc/supplier/user/update`,
      method: "post",
      headers: {
        "BIDDING-SOURCE": "PC",
        Authorization:
          "Bearer " +
          `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
      },
      data,
    });
  },

  opt(params) {
    return req.service({
      url: `${req.systemIp}/send/opt`,
      method: "get",
      headers: {
        "BIDDING-SOURCE": "PC",
        Authorization:
          "Bearer " +
          `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
      },
      params,
    });
  },

  //获取手机验证码
  getVCode(params) {
    return req.service({
      url: `${req.systemIp}/wx/supplier/user/send_sms`,
      method: "post",
      headers: {
        "BIDDING-SOURCE": "WX",
        "Content-Type": "multipart/form-data",
      },
      params,
    });
  },

  // 忘记密码
  findPassword(params) {
    return req.service({
      url: `${req.systemIp}/pc/ext/supplier/user/update`,
      method: "post",
      headers: {
        "BIDDING-SOURCE": "PC",
        "Content-Type": "multipart/form-data",
      },
      params,
    });
  },

  // 判定企业是否绑定CA-登录后
  ifLockCa(params) {
    return req.service({
      url: `${req.systemIp}/pc/supplier/ifLockCa`,
      method: "get",
      headers: {
        "BIDDING-SOURCE": "PC",
        Authorization:
          "Bearer " +
          `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
      },
      params,
    });
  },
  // 绑定CA 证书
  lockCa(params) {
    return req.service({
      url: `${req.systemIp}/pc/supplier/lockCa`,
      method: "get",
      headers: {
        "BIDDING-SOURCE": "PC",
        Authorization:
          "Bearer " +
          `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
      },
      params,
    });
  },
  // ca登录
  loginIfLockCa(params) {
    return req.service({
      url: `${req.systemIp}/pc/ext/supplier/loginIfLockCa`,
      method: "get",
      headers: {
        "BIDDING-SOURCE": "pc/ext",
      },
      params,
    });
  },
  // 解绑CA 证书
  unLockCa(params) {
    return req.service({
      url: `${req.systemIp}/pc/supplier/unLockCa`,
      method: "get",
      headers: {
        "BIDDING-SOURCE": "PC",
        Authorization:
          "Bearer " +
          `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
      },
      params,
    });
  },

  // 获取个人用户信息
  getUserInfo(params) {
    return req.service({
      url: `${req.systemIp}/pc/supplier/user/info`,
      method: "get",
      headers: {
        "BIDDING-SOURCE": "PC",
        Authorization:
          "Bearer " +
          `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
      },
      params,
    });
  },
};
